// 9fbef606107a605d69c0edbcd8029e5d
import { executeStatefulAPICall } from '../../handler';
import endpoints from '../../endpoints';
import { getAPIConfig, getPlaceSiteId } from '../../../utils';

export const forgotPasswordMS = (args) => {
  const payload = {
    header: {
      loginId: args.logonId,
      siteId: getPlaceSiteId(),
      target: args.target || 'email',
    },
    webService: endpoints.forgotPasswordMS,
  };
  return executeStatefulAPICall(payload)
    .then((res) => {
      if (!res.body) {
        throw new Error('res body is null');
      }
      return res.body.status;
    })
    .catch((err) => {
      throw err;
    });
};

export const forgotPassword = (args) => {
  if (args?.isSfccPlatform) {
    return forgotPasswordMS(args);
  }
  const apiConfig = getAPIConfig();
  const payload = {
    webService: endpoints.requestPassword,
    body: {
      langId: apiConfig.langId,
      catalogId: apiConfig.catalogId,
      storeId: apiConfig.storeId,
      target: args.target || 'email', // this needs to be moved to apiconfig
      ...args,
    },
  };
  return executeStatefulAPICall(payload)
    .then((res) => {
      if (!res.body) {
        throw new Error('res body is null');
        // TODO - Set API Helper to filter if error exists in response
      }
      return res.body.contact || [];
    })
    .catch((err) => {
      throw err;
    });
};
